import { isCopied } from '../state'
import { copyToClipboard } from './copy-to-clipboard'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Copy text with UI feedback
 * @param {string} text - Text to copy
 * @param {string} successMessage - Success message to display
 * @returns {Promise<boolean>} Success status
 */
export const copy = async (text, successMessage = 'Copied to clipboard') => {
  if (!text) return false

  try {
    const success = await copyToClipboard(text)
    if (success) {
      responseHandlerService.handleSuccess(successMessage)

      // Set copied flag for visual feedback
      isCopied.value = true
      setTimeout(() => {
        isCopied.value = false
      }, 2000)

      return true
    }
    return false
  } catch (error) {
    console.error('Failed to copy:', error)
    responseHandlerService.handleError('Failed to copy to clipboard')
    return false
  }
}
